<template>
    <footer>
        <div>PART OF THE PHOTOVISION FAMILY</div>

        <img src="@/assets/footer_logos.jpg" alt="Footer Logos">
    </footer>
</template>

<script>
    export default {
        name: "adminFooter"
    }
</script>

<style scoped>

</style>
